import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled from 'styled-components'

const Block = require('react-gutenberg').WPGBlock

const WPGColumnsBlock: React.FC<IWPGBlock> = (props) => {
  if (!Array.isArray(props.innerBlocks)) {
    console.warn('Columns should have innerBlocks')
    return null
  }

  const cols = props.innerBlocks.length

  const columns = props.innerBlocks.map((col, ci) => {
    let width = undefined
    let className = ''
    if (!Array.isArray(col.attrs)) {
      if (col.attrs.width) {
        width = col.attrs.width
      }
      if (col.attrs.className) {
        className = col.attrs.className
      }
    }

    return (
      <ColumnView key={ci} className={`wp-block-column ${ci + 1}-column ${className}`} width={width}>
        {col.innerBlocks.map((block, bi) => (
          <Block key={bi} block={block} />
        ))}
      </ColumnView>
    )
  })

  return (
    <div
      className={`wp-block-columns has-${cols}-columns ${
        !Array.isArray(props.attrs) ? props.attrs.className : undefined
      }`}
    >
      {columns}
    </div>
  )
}

const ColumnView = styled.div<{ width?: number }>`
  flex-grow: ${(props) => props.width};

  @media (max-width: 781px) {
    flex-basis: 100% !important;

    > svg {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 24px;
    }
  }
`

export default WPGColumnsBlock
